import { render, staticRenderFns } from "./DodajCertifikatePredelava.vue?vue&type=template&id=07233244&"
import script from "./DodajCertifikatePredelava.vue?vue&type=script&lang=js&"
export * from "./DodajCertifikatePredelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports